export const AI_PANEL_MIN = 280;
/** Цэс + үндсэн агуулгад дор хаяж ийм өргөн үлдээнэ (хяналтын самбар ~580px-ээс нарийнд эвдэрдэг). */
const MAIN_MIN = 800;

export function clampAiWidth(w: number): number {
  const max = Math.max(AI_PANEL_MIN, window.innerWidth - MAIN_MIN);
  return Math.round(Math.min(max, Math.max(AI_PANEL_MIN, w)));
}
